import { publicApiClient } from './publicApiClient';

export interface PublicVacancy {
  id: number; vacancy_reference: string; position_title: string | null; department_name: string | null;
  duty_station_name: string | null; employment_type: string | null; opening_date: string | null; closing_date: string | null; job_description: string | null; requirements?: string | null;
}

export interface EducationEntry { institution: string; degree?: string; fieldOfStudy?: string; startDate?: string; endDate?: string; isCurrent?: boolean }
export interface EmploymentEntry { employerName: string; positionTitle: string; startDate?: string; endDate?: string; isCurrent?: boolean; responsibilities?: string; reasonForLeaving?: string; supervisorName?: string; supervisorContact?: string }
export interface LanguageEntry { language: string; speakLevel?: string; readLevel?: string; writeLevel?: string }
export interface ReferenceEntry { fullName: string; relationship?: string; organization?: string; phone?: string; email?: string }
export interface DocumentUpload { dataUri: string; filename: string; documentType: 'cv_resume' | 'cover_letter' | 'identification' | 'certificate' | 'reference_letter' | 'other' }

export interface ApplicationSubmission {
  fullName: string; email: string; phone?: string;
  dateOfBirth?: string; gender?: string; nationality?: string;
  education: EducationEntry[]; employmentHistory: EmploymentEntry[]; currentEmployer?: string;
  languages: LanguageEntry[];
  coverLetter?: string; noticePeriodDays?: number; expectedSalary?: number; expectedSalaryCurrency?: string;
  willingToRelocate?: boolean; howHeardAboutVacancy?: string;
  references: ReferenceEntry[];
  relatedToStaff?: boolean; relatedToStaffDetails?: string;
  priorMisconductFinding?: boolean; priorMisconductDetails?: string;
  documents: DocumentUpload[];
}

export const publicRecruitmentApi = {
  listVacancies: () => publicApiClient.get<{ data: PublicVacancy[] }>('/api/public/vacancies'),
  getVacancy: (id: number) => publicApiClient.get<{ data: PublicVacancy }>(`/api/public/vacancies/${id}`),
  apply: (vacancyId: number, submission: ApplicationSubmission) =>
    publicApiClient.post<{ data: { message: string; documentsAttached: number; documentsRejected: number } }>(`/api/public/vacancies/${vacancyId}/apply`, submission),
};
